import { render, staticRenderFns } from "./winTeam_AD.vue?vue&type=template&id=13f0110b&scoped=true"
import script from "./winTeam_AD.vue?vue&type=script&lang=js"
export * from "./winTeam_AD.vue?vue&type=script&lang=js"
import style0 from "./winTeam_AD.vue?vue&type=style&index=0&id=13f0110b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f0110b",
  null
  
)

export default component.exports